import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t)}const n=(e,t)=>e??t;export{t as defaultTo};
//# sourceMappingURL=defaultTo-0HAp04Gk.js.map